import { Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import EditMyProfile from './EditmyProfile';
import MyProfileEdit from './MyProfile';

const UsersEditContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs justify='end' pageTitle='Edit Profile' parent='Users' title='Edit Profile' />
      <div className='edit-profile'>
        <Row>
          <Col xl='4'>
            <MyProfileEdit />
          </Col>
          <Col xl='8'>
            <EditMyProfile />
          </Col>
        </Row>
      </div>
    </Container>
  );
};
export default UsersEditContain;
